import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fff9009"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-nav-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

import { computed } from 'vue'
import { useStore } from '@/store'
import AppCustomTooltip from '@common/AppCustomTooltip.vue'
import MainNavigationNotifications from '@feature/main-navigation/MainNavigationNotifications.vue'
import NavigationUserProfile from '@feature/main-navigation/NavigationUserProfile.vue'
import { NavigationPanel } from '@/types/panel'


export default /*#__PURE__*/_defineComponent({
  props: {
  minimized: Boolean
},
  setup(__props) {

const store = useStore()
const trackingState = computed(() => store.getters['timetracker/getActiveTrackingStatus'])

async function signOut() {
  if (trackingState.value) await store.dispatch('timetracker/stopTracking')
  return store.dispatch('auth/signOut')
}



return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["side-nav-secondary", { 'side-nav-secondary--minimized': __props.minimized }])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Notifications" }, {
          default: _withCtx(() => [
            _createVNode(MainNavigationNotifications, {
              minimized: __props.minimized,
              "navigation-panel": _unref(NavigationPanel).NotificationPanel
            }, null, 8, ["minimized", "navigation-panel"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Settings" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: { path: `/settings` } }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "gear",
                  size: "18"
                }),
                (!__props.minimized)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Settings"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(AppCustomTooltip, { title: "Sign out" }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (signOut()))
            }, [
              _createVNode(_component_AppIcon, {
                name: "log-out",
                size: "21"
              }),
              (!__props.minimized)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Log out"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(NavigationUserProfile, { minimized: __props.minimized }, null, 8, ["minimized"])
  ], 2))
}
}

})